import {
  shouldBeShippedToday,
  getCountdown,
  shouldRenderNowCountdown
} from 'views/components/organisms/NowCountdown/helpers'

import toggleBoolStringAttribute from 'views/utils/toggleBoolStringAttribute'
import { ARIA_HIDDEN } from 'views/assets/scripts/consts'

const NOW_COUNTER_SELECTOR = '[data-clientside-hook~="now-countdown"]'
const NOW_COUNTER_WRAPPER_SELECTOR =
  '[data-clientside-hook~="now-countdown-wrapper"]'
const DELIVERY_DAYS_TODAY_SELECTOR =
  '[data-clientside-hook~="nowCountDownTodayText"]'
const DELIVERY_DAYS_TOMORROW_SELECTOR =
  '[data-clientside-hook~="nowCountDownTomorrowText"]'

export default () => {
  let nowCountdownWrapper = document.querySelector(NOW_COUNTER_WRAPPER_SELECTOR)

  let nowCounter = document.querySelector(NOW_COUNTER_SELECTOR)
  let todayText = document.querySelector(DELIVERY_DAYS_TODAY_SELECTOR)
  let tomorrowText = document.querySelector(DELIVERY_DAYS_TOMORROW_SELECTOR)
  const updateCountdown = () => {
    // If the countdown should be hidden while user sees it

    if (!shouldRenderNowCountdown()) {
      nowCountdownWrapper.parentElement.removeChild(nowCountdownWrapper)
      return
    }

    // If the elements are not visible anymore (e.g. because of the hydration)
    // we try to find them again and attach the required event listeners.
    if (!nowCountdownWrapper?.offsetParent) {
      nowCountdownWrapper = document.querySelector(NOW_COUNTER_WRAPPER_SELECTOR)

      if (nowCountdownWrapper) {
        nowCounter = document.querySelector(NOW_COUNTER_SELECTOR)
        todayText = document.querySelector(DELIVERY_DAYS_TODAY_SELECTOR)
        tomorrowText = document.querySelector(DELIVERY_DAYS_TOMORROW_SELECTOR)
      }
    }

    // If they are visible, do the normal UI changes
    if (nowCounter) {
      const countdown = getCountdown()
      nowCounter.innerHTML = countdown

      if (shouldBeShippedToday()) {
        toggleBoolStringAttribute(todayText, ARIA_HIDDEN, false)
        toggleBoolStringAttribute(tomorrowText, ARIA_HIDDEN, true)
      } else {
        toggleBoolStringAttribute(todayText, ARIA_HIDDEN, true)
        toggleBoolStringAttribute(tomorrowText, ARIA_HIDDEN, false)
      }
    }

    setTimeout(() => {
      requestAnimationFrame(updateCountdown)
    }, 1000)
  }

  requestAnimationFrame(updateCountdown)
}
